import React, { Component } from "react";
import { Fetch, downloadPDF } from "../../utils/fetch";
import Navbar from "../../components/newNavBar";
import Loader from "../../utils/loader";
import less from "./payouts.module.scss";
import moment from "moment";
import { DatePicker, ConfigProvider, Table, message } from "antd";
import { formatIndianCurrency } from "../../utils/common";

const { RangePicker } = DatePicker;

function downloadBase64File(base64, fileName) {
  const blob = new Blob([base64], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
}

const columns = [
  {
    title: "BO Name",
    dataIndex: "name",
  },
  {
    title: "Payout Amount",
    dataIndex: "amount",
  },
  {
    title: "Billing Start Date",
    dataIndex: "startDate",
  },
  {
    title: "Billing End Date",
    dataIndex: "endDate",
  },
  {
    title: "Inv. Generated On",
    dataIndex: "time",
  },
  {
    title: "Generated by System",
    dataIndex: "isSystem",
  },
  {
    title: "Payment Advice",
    dataIndex: "action",
    render: ({ downloadExcel }) => (
      <button onClick={downloadExcel} className={less.download}>
        Download
      </button>
    ),
  },
];

class seatFare extends Component {
  state = {
    loading: true,
    tableData: [],
  };

  async componentDidMount() {
    try {
      const stateObj = { loading: true };
      await this.fetchPayouts();
      stateObj.loading = false;
      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      stateObj.isMobile = regex.test(navigator.userAgent);
      this.setState(stateObj);
    } catch (err) {
      console.log(err);
    }
  }

  formatTable = (payout) => {
    let stateObj = {};
    let data = [];
    let headerData = {
      billingStartDate: moment(payout[0].billingStartDate).format("LL"),
      billingEndDate: moment(payout[0].billingEndDate).format("LL"),
      generatedOn: moment(payout[0].createdOn).format("LL"),
      amount: formatIndianCurrency(payout[0].paymentAmount),
    };
    stateObj.headerData = headerData;
    for (let i = 0; i < payout.length; i++) {
      let payoutData = payout[i];
      let tab = {
        name: payoutData.operatorUser.name,
        startDate: moment(payoutData.billingStartDate).format("LL"),
        endDate: moment(payoutData.billingEndDate).format("LL"),
        time: moment(payoutData.createdOn).format("LL"),
        isSystem: payoutData.createdBySystem ? "true" : "false",
        amount: formatIndianCurrency(payoutData.paymentAmount),
        action: {
          downloadExcel: () => this.downloadExcel(payoutData),
        },
      };
      data.push(tab);
    }
    stateObj.tableData = data;
    this.setState(stateObj);
  };

  downloadExcel = async (payoutData) => {
    let report = payoutData.pnrWiseReport;
    let link;
    if (report) {
      link = "https://d1sk77eomznq49.cloudfront.net/" + report;
      const a = document.createElement("a");
      a.href = link;
      a.download = "Weekly report";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      const url = `/user/weeklyReport?fromDate=${payoutData.billingStartDate}&toDate=${payoutData.billingEndDate}`;
      const options = {
        method: "get",
      };

      link = await downloadPDF(url, options);

      const fileName = `pnrwisereport_${payoutData.billingStartDate}_${payoutData.billingEndDate}.xlsx`;

      downloadBase64File(link, fileName);
    }
    return;
  };

  fetchPayouts = async (fromDate, toDate) => {
    let url = `/user/payout`;
    if (fromDate && toDate) {
      url += `?fromDate=${fromDate}&toDate=${toDate}`;
    }
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);
    if (!Array.isArray(response)) {
      message.error("No Data Found");
      return;
    }
    if (response) {
      this.formatTable(response);
    }
    return null;
  };

  onRangeChange = async (dates, dateStrings) => {
    let fromDate, toDate;
    if (dates) {
      fromDate = moment(dateStrings[0], "DD/MM/YYYY").valueOf();
      toDate = moment(dateStrings[1], "DD/MM/YYYY").valueOf();
      this.setState({ fromDate, toDate });
    } else {
      console.log("Clear");
    }
    this.fetchPayouts(fromDate, toDate);
  };

  render() {
    const { loading, isMobile, tableData, headerData } = this.state;
    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    } else {
      return (
        <div>
          <Navbar selectedKey={5.2} isMobile={isMobile} />
          <div class="container">
            <div className={less.Header}>
              <span className="dealSpan">Payout DashBoard</span>
              <div>
                <span>Select date range:</span>
                <ConfigProvider
                  theme={{
                    token: {
                      colorPrimary: "#7b2bff",
                    },
                  }}
                >
                  <RangePicker
                    onChange={this.onRangeChange}
                    format="DD/MM/YYYY"
                  />
                </ConfigProvider>
              </div>
            </div>
            <div className={less.info}>
              <span>Last Invoice Details</span>
              <div className={less.grid}>
                <div>
                  <span>Invoice Generated On:</span>
                  <span>{headerData ? headerData.generatedOn : null}</span>
                </div>
                <div>
                  <span>Billing start date :</span>
                  <span>{headerData ? headerData.billingStartDate : null}</span>
                </div>
                <div>
                  <span>Billing end date : </span>
                  <span>{headerData ? headerData.billingEndDate : null}</span>
                </div>
                <div>
                  <span>Payment Amount :</span>
                  <span>{headerData ? headerData.amount : null}</span>
                </div>
              </div>
            </div>
            <div>
              <ConfigProvider
                theme={{
                  token: {
                    fontFamily: "Poppins",
                    fontSize: 12,
                  },
                  components: {
                    Table: {
                      headerBg: "#F5F5F5",
                    },
                  },
                }}
              >
                <Table
                  columns={columns}
                  dataSource={tableData}
                  pagination={false}
                ></Table>
              </ConfigProvider>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default seatFare;
